module.exports = __webpack_public_path__ + "img/musescore.df551700.svg";